import React, { useState } from "react";
import "../ViewSpecialOnBoarding.css";
import { Paper, InputBase, Button } from "@mui/material";
import { SearchOutlined, CloseCircleFilled } from "@ant-design/icons";

const SpecialOnBoardingSearch = ({ isSearching, setIsSearching, onClickSearch }) => {
  const [searchFlightData, setSearchFlightData] = useState("");

  const handleSearchChange = (event) => {
    const value = event.target.value;
    setSearchFlightData(value);
    if (value.length === 0) {
      setIsSearching(false);
    }
  };

  const handleSearchClear = () => {
    setSearchFlightData("");
    setIsSearching(false);
  };

  return (
    <div className="view-special-onboarding-search ">
      <Paper component="form" className="paper-style" onSubmit={e => e.preventDefault()}>
        <SearchOutlined className="input-icon" />
        <InputBase
          className="input-style"
          placeholder="Search by Flight Number"
          value={searchFlightData}
          onChange={handleSearchChange}
          inputProps={{ maxLength: 15 }}
        />
        {searchFlightData.length > 0 && (
          <CloseCircleFilled
            className="input-icon"
            onClick={handleSearchClear}
          />
        )}
        <Button
          variant="contained"
          disabled={searchFlightData.length < 3}
          onClick={() => onClickSearch(searchFlightData)}
        >
          Search
        </Button>
      </Paper>
    </div>
  );
};

export default SpecialOnBoardingSearch;
